import React from "react";
import { CompanyNewsTileType } from "@irati/types";
import { StyledImage, StyledImageTile, StyledContentWrapper } from "./styled";
import Message from "./Message";
var ImageTile = function (_a) {
    var companyNewsTile = _a.companyNewsTile;
    var _b = companyNewsTile.config, imageUrl = _b.imageUrl, message = _b.message, type = _b.type;
    if (type !== CompanyNewsTileType.Image) {
        return null;
    }
    return (React.createElement(StyledImageTile, null,
        React.createElement(StyledContentWrapper, null,
            React.createElement(StyledImage, { imageUrl: imageUrl })),
        React.createElement(Message, { message: message })));
};
export default ImageTile;
